import React from 'react';

const SvgIcMobile = ({ color, ...props }) => (
  <svg
    width={props.size || 15.701}
    height={props.size || 27.707}
    viewBox="0 0 15.701 27.707"
    style={{ color }}
    {...props}
  >
    <g data-name="Group 432">
      <g data-name="Group 427">
        <g data-name="Group 426">
          <path
            data-name="Path 451"
            d="M8.399 23.134h-1.1a1.221 1.221 0 00-1.219 1.219v.214a1.22 1.22 0 001.219 1.219h1.1a1.22 1.22 0 001.219-1.219v-.214a1.221 1.221 0 00-1.219-1.219zm.335 1.433a.335.335 0 01-.335.335h-1.1a.335.335 0 01-.335-.335v-.214a.336.336 0 01.335-.335h1.1a.336.336 0 01.335.335z"
            fill="currentColor"
          />
        </g>
      </g>
      <g data-name="Group 429">
        <g data-name="Group 428">
          <path
            data-name="Path 452"
            d="M14.031 0H1.666A1.671 1.671 0 00-.003 1.669v24.369a1.671 1.671 0 001.669 1.669h12.362a1.671 1.671 0 001.669-1.669V1.669A1.671 1.671 0 0014.031 0zm.745 26.038a.747.747 0 01-.745.746H1.666a.747.747 0 01-.746-.745V1.669a.747.747 0 01.746-.745h12.362a.747.747 0 01.746.746v24.368z"
            fill="currentColor"
          />
        </g>
      </g>
      <path
        data-name="Line 91"
        fill="none"
        stroke="currentColor"
        d="M.817 21.354h14"
      />
    </g>
  </svg>
);

export default SvgIcMobile;
